var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadingBloodPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#a4c0c9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,183.5A7.93,7.93,0,0,1,95.39,182,351.12,351.12,0,0,1,56.33,149.1C29.49,122.74,15.87,99.41,15.87,79.75c0-23.69,13.68-43.6,34.84-50.74,17.42-5.87,35.61-1.38,49.29,11.7,13.68-13.08,31.87-17.57,49.29-11.7,21.16,7.14,34.83,27.05,34.83,50.74,0,19.66-13.61,43-40.45,69.35A351.12,351.12,0,0,1,104.61,182,8,8,0,0,1,100,183.5Zm-34-141a31.56,31.56,0,0,0-10.17,1.71C41.28,49.08,31.87,63,31.87,79.75c0,28.9,45.53,68.94,68.13,85.86,22.6-16.92,68.12-57,68.12-85.86,0-16.71-9.4-30.67-23.94-35.57-13.78-4.65-27.92.35-37.81,13.36a8,8,0,0,1-12.74,0C86.17,47.73,76.3,42.47,66,42.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingBloodPressure);
export default __webpack_public_path__ + "static/media/Reading - Blood Pressure.76a89372bb3244087cb6e926d3970ae0.svg";
export { ForwardRef as ReactComponent };